import { render, staticRenderFns } from "./PayPage.vue?vue&type=template&id=21fc7edd&scoped=true&"
import script from "./PayPage.vue?vue&type=script&lang=js&"
export * from "./PayPage.vue?vue&type=script&lang=js&"
import style0 from "./PayPage.vue?vue&type=style&index=0&id=21fc7edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc7edd",
  null
  
)

export default component.exports